import { useResource } from '@landsbankinn/l16n';
import {
  Box,
  Button,
  Checkbox,
  Col,
  Flex,
  InputContainer,
  Label,
  P,
} from '@landsbankinn/ui-kit';
import { res } from './AppLoginQR.res';
import { AppQR } from './AppQR';

export type AppLoginQRProps = {
  isMobile?: boolean;
  isXL?: boolean;
  isPersistent: boolean;
  isUsers: boolean;
  onRememberMe: (isPersistent: boolean) => void;
  onUsers: () => void;
};

export function AppLoginQR({
  isMobile,
  isXL,
  isPersistent,
  isUsers,
  onRememberMe,
  onUsers,
}: AppLoginQRProps) {
  const { r } = useResource();

  return (
    <Col rowGap="36" paddingTop="36" id="tab-content" grow="1">
      {!isMobile && (
        <>
          <P color="common blue font" fontVariant="body">
            {r(res.scanQrCode)}
          </P>
          {!isXL && <AppQR isMobile={false} />}
          <InputContainer
            paddingTop="27"
            paddingBottom="16"
            borderBottom="thin"
          >
            <Flex crossAxisAlignment="center" colGap="12">
              <Checkbox
                id="persistent"
                onValueChange={() => onRememberMe(!isPersistent)}
                dir="row"
                checked={isPersistent}
                instrumentAs="remember_me_checkbox"
              />
              <Label
                htmlFor="persistent"
                color="common blue font"
                fontWeight="medium"
                fontVariant="body"
              >
                {r(res.rememberMeLabel)}
              </Label>
            </Flex>
            <P marginLeft="36" color="common blue font" fontVariant="body">
              {r(res.rememberMe)}
            </P>
          </InputContainer>
          {isUsers && (
            <Button
              instrumentAs="show_known_users"
              style={{ marginTop: '36px' }}
              variant="secondary"
              onClick={onUsers}
            >
              {r(res.savedUsers)}
            </Button>
          )}
        </>
      )}
      {isMobile && (
        <>
          <P color="common blue font" fontVariant="body">
            {r(res.loginUsingApp)}
          </P>
          <Box grow="1" />
          <AppQR isMobile={true} />
        </>
      )}
    </Col>
  );
}
